// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#OrdersListTo_component .container_orders .header {
  width: 100%;
}
#OrdersListTo_component .container_orders .list_and_information {
  display: flex;
  font-size: 13px;
}
#OrdersListTo_component .list_and_information .orders_list {
  width: 100%;
}
#OrdersListTo_component .list_and_information .orders_list table {
  font-size: 13px;
}
#OrdersListTo_component .list_and_information .orders_list table thead tr th {
  background-color: #8BA6ED;
  border: none;
  font-size: 18px;
  font-weight: 500;
  border-right: 1px solid;
}
#OrdersListTo_component .list_and_information .orders_list table thead tr th.created {
  width: 150px;
}
#OrdersListTo_component .list_and_information .orders_list table tbody tr {
  cursor: pointer;
}
#OrdersListTo_component .list_and_information .orders_list table tbody tr:hover {
  background-color: #CDD8F6;
}
#OrdersListTo_component .list_and_information .orders_list table tbody tr td {
  border: none;
}
#OrdersListTo_component .list_and_information .orders_list table tbody tr td .add_express_manufacturing {
  color: red;
}
#OrdersListTo_component .list_and_information .orders_list table tbody tr td .details-link {
  color: #CBA5AC;
}
#OrdersListTo_component .order_information {
  width: 100%;
  padding: 0 20px;
  position: absolute;
  right: 0;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
}
#OrdersListTo_component .order_information .order-head .order-number {
  width: 50%;
  display: inline-block;
}
#OrdersListTo_component .order_information .order-head .order-number h1 {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .order-head .link_to_detail {
  width: 50%;
  display: inline-block;
}
#OrdersListTo_component .order_information .order-head .link_to_detail .button_link {
  background-color: transparent;
  float: right;
  color: black;
  width: max-content;
  font-size: 20px;
  line-height: 52px;
}
#OrdersListTo_component .order_information .order-head .link_to_detail .button_link .details-icon {
  background-color: #8BA6ED;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: inline-block;
  color: white;
  margin-left: 5px;
}
#OrdersListTo_component .order_information .order-country-date-data {
  background-color: white;
  padding: 15px;
  margin: 15px 0px;
  font-weight: bold;
}
#OrdersListTo_component .order_information .order-country-date-data .date-div .date {
  font-weight: normal;
}
#OrdersListTo_component .order_information .order-country-date-data .country-div .country {
  font-weight: normal;
}
#OrdersListTo_component .order_information .customers_information {
  background-color: white;
  border: 1px solid #f8f8f8;
  border-top-right-radius: 15px;
  margin-bottom: 15px;
}
#OrdersListTo_component .order_information .customers_information .customer-heading {
  color: white;
  text-align: left !important;
  background-color: #74CDD2 !important;
  padding: 7px 15px;
  border-top-right-radius: 15px;
}
#OrdersListTo_component .order_information .customers_information .customer-data {
  padding: 15px;
}
#OrdersListTo_component .order_information .customers_information .customer-data .shipping-info {
  margin-bottom: 15px;
}
#OrdersListTo_component .order_information .customers_information .customer-data .shipping-info .shipping-info-heading {
  font-weight: bold;
  border: none;
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .shipping-info .name {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .shipping-info .address {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .shipping-info .number {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .billing-info {
  margin-bottom: 15px;
}
#OrdersListTo_component .order_information .customers_information .customer-data .billing-info .shipping-info-heading {
  font-weight: bold;
  border: none;
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .billing-info .name {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .billing-info .address {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .customers_information .customer-data .billing-info .number {
  margin-bottom: 0;
}
#OrdersListTo_component .order_information .products_information {
  background-color: white;
  border: 1px solid #f8f8f8;
  border-top-right-radius: 15px;
  margin-bottom: 15px;
}
#OrdersListTo_component .order_information .products_information .product-heading {
  color: white;
  text-align: left !important;
  background-color: #F2D499 !important;
  padding: 7px 15px;
  border-top-right-radius: 15px;
}
#OrdersListTo_component .order_information .products_information .product-details {
  padding: 15px;
}
#OrdersListTo_component .order_information .products_information .product-details .diamond {
  margin-bottom: 0;
  width: 50%;
  display: inline-block;
  float: left;
}
#OrdersListTo_component .order_information .products_information .product-details .diamond h4 {
  margin-bottom: 0;
  border: none;
  font-weight: bold;
}
#OrdersListTo_component .order_information .products_information .product-details .diamond .product-link {
  color: #CBA5AC;
}
#OrdersListTo_component .order_information .products_information .product-details .setting {
  margin-bottom: 0;
  width: 50%;
  display: inline-block;
  float: right;
}
#OrdersListTo_component .order_information .products_information .product-details .setting h4 {
  margin-bottom: 0;
  border: none;
  font-weight: bold;
}
#OrdersListTo_component .order_information .products_information .product-details .setting .product-link {
  color: #CBA5AC;
}
#OrdersListTo_component .order_information .payment_information {
  background-color: white;
  border: 1px solid #f8f8f8;
  border-top-right-radius: 15px;
  margin-bottom: 15px;
}
#OrdersListTo_component .order_information .payment_information .payment-heading {
  color: white;
  text-align: left !important;
  background-color: #F47548 !important;
  padding: 7px 15px;
  border-top-right-radius: 15px;
}
#OrdersListTo_component .order_information .payment_information .payment-details {
  padding: 15px;
}
#OrdersListTo_component .order_information .payment_information .payment-details .total-to-pay {
  font-weight: bold;
  border: none;
}
#OrdersListTo_component .order_information .payment_information .payment-details .total-to-pay .paying-amount {
  font-weight: normal;
}
#OrdersListTo_component .order_information .payment_information .payment-details .total-pay {
  font-weight: bold;
  border: none;
}
#OrdersListTo_component .order_information .payment_information .payment-details .total-pay .paying-amount {
  font-weight: normal;
}
#OrdersListTo_component .order_information h2 {
  text-align: center;
  padding: 6px 2px;
}
#OrdersListTo_component .order_information .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
}
#OrdersListTo_component .order_information .choose_message span {
  font-size: 40px;
}
#OrdersListTo_component .order_information .link_to_detail {
  float: right;
}
#OrdersListTo_component .order_information .details {
  padding: 6px 6px;
}
#OrdersListTo_component .order_information .customers_information .details .billing_information {
  margin-top: 20px;
}
#OrdersListTo_component .order_information .payment_information {
  margin-top: 20px;
  border: 1px solid #FFB7B2;
}
#OrdersListTo_component .order_information .payment_information h2 {
  background-color: #FFB7B2;
}
#OrdersListTo_component .order_information .products_information .diamond {
  padding: 4px 6px;
  width: 50%;
}
#OrdersListTo_component .order_information .products_information .setting {
  padding: 4px 6px;
  width: 50%;
}
#OrdersListTo_component .order_information .history {
  margin-top: 20px;
  border: 1px solid #E2F0CB;
}
#OrdersListTo_component .order_information .history h2 {
  background-color: #E2F0CB;
}
#OrdersListTo_component .order_information .manufacturing_information {
  margin-top: 20px;
  border: 1px solid #B5EAD7;
}
#OrdersListTo_component .order_information .manufacturing_information h2 {
  background-color: #B5EAD7;
}
#OrdersListTo_component .order_information .discussion {
  margin-top: 20px;
  border: 1px solid #C7CEEA;
}
#OrdersListTo_component .order_information .discussion h2 {
  background-color: #C7CEEA;
}`, "",{"version":3,"sources":["webpack://./src/css/orders.scss"],"names":[],"mappings":"AAcQ;EACI,WAAA;AAbZ;AAeQ;EACI,aAAA;EACA,eAZQ;AADpB;AAqBQ;EACI,WAAA;AAnBZ;AAoBY;EACI,eAvBI;AAKpB;AAqBwB;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAnB5B;AAoB4B;EACI,YAAA;AAlBhC;AAwBoB;EACI,eAAA;AAtBxB;AAuBwB;EACI,yBAAA;AArB5B;AAuBwB;EACI,YAAA;AArB5B;AAsB4B;EACI,UAAA;AApBhC;AAsB4B;EACI,cAAA;AApBhC;AAgCI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AA9BR;AAgCY;EACI,UAAA;EACA,qBAAA;AA9BhB;AA+BgB;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AA7BpB;AAgCY;EACI,UAAA;EACA,qBAAA;AA9BhB;AA+BgB;EACI,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AA7BpB;AA8BoB;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA5BxB;AAiCQ;EACI,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AA/BZ;AAiCgB;EACI,mBAAA;AA/BpB;AAmCgB;EACI,mBAAA;AAjCpB;AAqCQ;EACI,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AAnCZ;AAoCY;EACI,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AAlChB;AAoCY;EACI,aAAA;AAlChB;AAmCgB;EACI,mBAAA;AAjCpB;AAkCoB;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAmCgB;EACI,mBAAA;AAjCpB;AAkCoB;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAkCoB;EACI,gBAAA;AAhCxB;AAqCQ;EACI,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AAnCZ;AAoCY;EACI,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AAlChB;AAoCY;EACI,aAAA;AAlChB;AAmCgB;EACI,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;AAjCpB;AAkCoB;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;AAhCxB;AAkCoB;EACI,cAAA;AAhCxB;AAmCgB;EACI,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;AAjCpB;AAkCoB;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;AAhCxB;AAkCoB;EACI,cAAA;AAhCxB;AAqCQ;EACI,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AAnCZ;AAoCY;EACI,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,6BAAA;AAlChB;AAoCY;EACI,aAAA;AAlChB;AAmCgB;EACI,iBAAA;EACA,YAAA;AAjCpB;AAkCoB;EACI,mBAAA;AAhCxB;AAmCgB;EACI,iBAAA;EACA,YAAA;AAjCpB;AAkCoB;EACI,mBAAA;AAhCxB;AAqCQ;EACI,kBAAA;EACA,gBAAA;AAnCZ;AAqCQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;AAnCZ;AAoCY;EACI,eAAA;AAlChB;AAqCQ;EACI,YAAA;AAnCZ;AAqCQ;EACI,gBAAA;AAnCZ;AA2CgB;EACI,gBAAA;AAzCpB;AAgDQ;EACI,gBAAA;EAIA,yBAAA;AAjDZ;AA8CY;EACI,yBA3RF;AA+Od;AAoDY;EACI,gBAAA;EACA,UAAA;AAlDhB;AAoDY;EACI,gBAAA;EACA,UAAA;AAlDhB;AAwDQ;EACI,gBAAA;EAIA,yBAAA;AAzDZ;AAsDY;EACI,yBAhTF;AA4Pd;AA2DQ;EACI,gBAAA;EAIA,yBAAA;AA5DZ;AAyDY;EACI,yBAzTF;AAkQd;AA8DQ;EACI,gBAAA;EAIA,yBAAA;AA/DZ;AA4DY;EACI,yBAlUA;AAwQhB","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n\n#OrdersListTo_component{\n    // ------------------------\n    //GENERAL DESIGN\n    // ------------------------\n    .container_orders {\n        .header {\n            width: 100%;\n        }\n        .list_and_information {\n            display: flex;\n            font-size: $font_size_content;\n        }\n    }\n\n    // ------------------------\n    //LEFT PANEL\n    // ------------------------\n    .list_and_information {\n        .orders_list {\n            width: 100%;\n            table {\n                font-size: $font_size_content;\n                thead {\n                    tr {\n                        th {\n                            background-color: #8BA6ED;\n                            border: none;\n                            font-size: 18px;\n                            font-weight: 500;\n                            border-right: 1px solid;\n                            &.created {\n                                width: 150px;\n                            }\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        cursor: pointer;\n                        &:hover {\n                            background-color: #CDD8F6;\n                        }\n                        td {\n                            border: none;\n                            .add_express_manufacturing {\n                                color: red;\n                            }\n                            .details-link {\n                                color: #CBA5AC;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // ------------------------\n    //RIGHT PANEL\n    // ------------------------\n    .order_information {\n        width: 100%;\n        padding: 0 20px;\n        position: absolute;\n        right: 0;\n        height: 100%;\n        overflow: auto;\n        padding-bottom: 100px;\n        .order-head {\n            .order-number {\n                width: 50%;\n                display: inline-block;\n                h1 {\n                    font-weight: bold;\n                    font-size: 20px;\n                    margin-bottom: 0;\n                }\n            }\n            .link_to_detail {\n                width: 50%;\n                display: inline-block;\n                .button_link {\n                    background-color: transparent;\n                    float: right;\n                    color: black;\n                    width: max-content;\n                    font-size: 20px;\n                    line-height: 52px;\n                    .details-icon {\n                        background-color: #8BA6ED;\n                        width: 50px;\n                        height: 50px;\n                        border-radius: 50%;\n                        display: inline-block;\n                        color: white;\n                        margin-left: 5px;\n                    }\n                }\n            }\n        }\n        .order-country-date-data {\n            background-color: white;\n            padding: 15px;\n            margin: 15px 0px;\n            font-weight: bold;\n            .date-div {\n                .date {\n                    font-weight: normal;\n                }\n            }\n            .country-div {\n                .country {\n                    font-weight: normal;\n                }\n            }\n        }\n        .customers_information {\n            background-color: white;\n            border: 1px solid #f8f8f8;\n            border-top-right-radius: 15px;\n            margin-bottom: 15px;\n            .customer-heading {\n                color: white;\n                text-align: left!important;\n                background-color: #74CDD2!important;\n                padding: 7px 15px;\n                border-top-right-radius: 15px;\n            }\n            .customer-data {\n                padding: 15px;\n                .shipping-info {\n                    margin-bottom: 15px;\n                    .shipping-info-heading {\n                        font-weight: bold;\n                        border: none;\n                        margin-bottom: 0;\n                    }\n                    .name {\n                        margin-bottom: 0;\n                    }\n                    .address {\n                        margin-bottom: 0;\n                    }\n                    .number {\n                        margin-bottom: 0;\n                    }\n                }\n                .billing-info {\n                    margin-bottom: 15px;\n                    .shipping-info-heading {\n                        font-weight: bold;\n                        border: none;\n                        margin-bottom: 0;\n                    }\n                    .name {\n                        margin-bottom: 0;\n                    }\n                    .address {\n                        margin-bottom: 0;\n                    }\n                    .number {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n        .products_information {\n            background-color: white;\n            border: 1px solid #f8f8f8;\n            border-top-right-radius: 15px;\n            margin-bottom: 15px;\n            .product-heading {\n                color: white;\n                text-align: left!important;\n                background-color: #F2D499!important;\n                padding: 7px 15px;\n                border-top-right-radius: 15px;\n            }\n            .product-details {\n                padding: 15px;\n                .diamond {\n                    margin-bottom: 0;\n                    width: 50%;\n                    display: inline-block;\n                    float: left;\n                    h4 {\n                        margin-bottom: 0;\n                        border: none;\n                        font-weight: bold;\n                    }\n                    .product-link {\n                        color: #CBA5AC;\n                    }\n                }\n                .setting {\n                    margin-bottom: 0;\n                    width: 50%;\n                    display: inline-block;\n                    float: right;\n                    h4 {\n                        margin-bottom: 0;\n                        border: none;\n                        font-weight: bold;\n                    }\n                    .product-link {\n                        color: #CBA5AC;\n                    }\n                }\n            }\n        }\n        .payment_information {\n            background-color: white;\n            border: 1px solid #f8f8f8;\n            border-top-right-radius: 15px;\n            margin-bottom: 15px;\n            .payment-heading {\n                color: white;\n                text-align: left!important;\n                background-color: #F47548!important;\n                padding: 7px 15px;\n                border-top-right-radius: 15px;\n            }\n            .payment-details {\n                padding: 15px;\n                .total-to-pay {\n                    font-weight: bold;\n                    border: none;\n                    .paying-amount {\n                        font-weight: normal;\n                    }\n                }\n                .total-pay {\n                    font-weight: bold;\n                    border: none;\n                    .paying-amount {\n                        font-weight: normal;\n                    }\n                }\n            }\n        }\n        h2 {\n            text-align: center;\n            padding: 6px 2px;\n        }\n        .choose_message {\n            margin-top: 50px;\n            text-align: center;\n            font-size: 30px;\n            span {\n                font-size: 40px;\n            }\n        }\n        .link_to_detail {\n            float: right;\n        }\n        .details {\n            padding: 6px 6px;\n        }\n    }\n\n    .order_information {\n        .customers_information {\n            .details {\n                .shipping_information {}\n                .billing_information {\n                    margin-top: 20px;\n                }\n            }\n        }\n    }\n\n    .order_information {\n        .payment_information {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_red_2;\n            }\n            border: 1px solid $color_red_2;\n        }\n    }\n\n    .order_information {\n        .products_information {\n            .diamond {\n                padding: 4px 6px;\n                width: 50%;\n            }\n            .setting {\n                padding: 4px 6px;\n                width: 50%;\n            }\n        }\n    }\n\n    .order_information {\n        .history {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_grass;\n            }\n            border: 1px solid $color_grass;\n        }\n    }\n\n    .order_information {\n        .manufacturing_information {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_green;\n            }\n            border: 1px solid $color_green;\n        }\n    }\n\n    .order_information {\n        .discussion {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_purlple;\n            }\n            border: 1px solid $color_purlple;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
